import React, { useState,useEffect } from 'react';
import SectionStatic from './SectionStatic';
const Section = ({sp,ssId,sdId}) => 
{
  const appLanguage = localStorage.getItem('appLanguage') || 'en';
  const[ssData,setData]=useState([])
  useEffect(()=>
  {
    const sectionDetail = async () => 
    {
      try 
      {
        const response = await fetch(global.config.API_URL+"section/"+ssId);
        const result = await response.json();
        setData(result[0]);
        if( global.config.IsPrint === true )
        {
          console.info('Section Detail : Result',result);
        }
      }
      catch (error) 
      {
        console.error('Section Detail : Error', error.message);
      }
    };
    sectionDetail();
  },[ssId,sdId]);
  return (
      <React.Fragment>
      { ssData && ssData.ss_dynamic === 1 ? (
        <React.Fragment>
          <SectionStatic sp={sp} sectionData={ssData} sdId={sdId} />
        </React.Fragment>
      ) : (
        <React.Fragment>
        <div dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (ssData.ss_detail_hi ? ssData.ss_detail_hi : ssData.ss_detail) : ssData.ss_detail }}></div>
        </React.Fragment>
      )}                    
      </React.Fragment>
  );
}
export default Section;